var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h3',[_vm._v("热门机型")]),_c('div',{},_vm._l((_vm.showHotProductList),function(item,index){return _c('div',{key:index,staticClass:"product_item_box",on:{"click":function($event){return _vm.productItemClick(item)}}},[_c('img',{attrs:{"src":item.listSrc,"alt":""}}),_c('p',[_vm._v(_vm._s(item.id))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }